import { render, staticRenderFns } from "./SOVamdIndia.vue?vue&type=template&id=771fac72&scoped=true"
import script from "./SOVamdIndia.vue?vue&type=script&lang=js"
export * from "./SOVamdIndia.vue?vue&type=script&lang=js"
import style0 from "./SOVamdIndia.vue?vue&type=style&index=0&id=771fac72&prod&scoped=true&lang=css"
import style1 from "./SOVamdIndia.vue?vue&type=style&index=1&id=771fac72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771fac72",
  null
  
)

export default component.exports